import React, {Fragment, useEffect, useState} from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";
import Select from "../../form/Select";
import AddressControl from "../../form/AddressControl";
import {CurrencyFormatter, optionsTemplate, PeriodFormatter, UnitFormatter} from "../../../utils/formatters";
import classNames from 'classnames';
import Button from "../../form/Button";
import {connect} from "src/store";
import DateTimeInput from "../../form/DateTimeInput";
import TextArea from "../../form/TextArea";
import {get} from "../../../utils/dotutils";
import {postData} from "../../../utils/request";
import {fieldFilter, loadComponent} from "../../../utils/components";
import moment from "moment";
import DetailsButton from "../../form/DetailsButton";
import QuizAnswerField from "./QuizAnswer/QuizAnswerField";
import Collapse from "../../layout/Collapse";
import ComponentLoader from "../../form/ComponentLoader";
import EventReservationOptionEditor from "../EventReservationOptionEditor";
import ModalEditor from "../ModalEditor";
import FragmentEditor from "../FragmentEditor";

const QuizAnswers = (props) => {
    const [maxBatchId, setMaxBatchId] = useState(0);
    useEffect(() => {
        (async () => {
            const quizAnswer = await loadComponent("QuizAnswer", {
                filter: [
                    {field: "component_type", value: props.componentConfig.componentname},
                    {field: "component_id", value: props.values[props.componentConfig.idfield]}
                ],
                order: {
                    field: "batch_id",
                    direction: "desc"
                },
                limit: 1
            });
            setMaxBatchId(quizAnswer?.batch_id || 0);
        })();
    },[props.values[props.componentConfig.idfield], props.componentConfig.componentname]);
    return <Fragment>
        {props.values?.event?.program?.quizzes?.map((quiz, idx) => {
            if (quiz.type + "" === "2") {
                return <QuizAnswerField
                    label={false}
                    key={idx}
                    quiz_id={quiz.id}
                    filter={[
                        {field: "component_type", value: props.componentConfig.componentname},
                        {field: "component_id", value: props.values[props.componentConfig.idfield]}
                    ]}
                />
            }
        })}
        {maxBatchId > 0 && Array(parseInt(maxBatchId)).fill('').map((v, batch_id) => {
            return <Collapse
                key={batch_id}
                button={<Button color="default" block={true}>
                    {batch_id + 1}. Résztvevő adatai
                </Button>}
            >
                <div className="row form-row">
                    <div className="col-sm-12">
                        <div className="form-group">
                            <label className="control-label">{batch_id + 1}. Résztvevő adatai</label>
                            {props.values?.event?.program?.quizzes?.map((quiz, idx) => {
                                if (quiz.type + "" === "3") {
                                    return <QuizAnswerField
                                        key={idx}
                                        label={false}
                                        quiz_id={quiz.id}
                                        filter={[
                                            {field: "batch_id", value: batch_id + 1},
                                            {field: "component_type", value: props.componentConfig.componentname},
                                            {field: "component_id", value: props.values[props.componentConfig.idfield]}
                                        ]}
                                    />
                                }
                            })}
                        </div>
                    </div>
                </div>
            </Collapse>
        })}
    </Fragment>
}

class EventReservationForm extends React.Component {

    render() {
        const disabled = !!this.props.values[this.props.componentConfig.idfield];
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    {this.props.values.eventpurchase && <div className="col-md-12">
                        <div className="form-group">
                            <DetailsButton
                                component_type={this.props.componentConfig.fielddefs.eventpurchase.object}
                                component_id={this.props.values.eventpurchase.id}
                            />
                        </div>
                    </div>}
                    <div className="col-md-2">
                        <TextInput
                            name={this.props.componentConfig.idfield}
                            value={this.props.values[this.props.componentConfig.idfield]}
                            label="Kód"
                            role="idfield"
                            {...this.props.getFieldProps(this.props.componentConfig.idfield)}
                        />
                    </div>
                    {!this.props.presets?.event && <div className="col-md-2">
                        <DateTimeInput
                            name="created_at"
                            value={this.props.values.created_at}
                            label="Foglalás dátuma"
                            {...this.props.getFieldProps("created_at")}
                            disabled="disabled"
                        />
                    </div>}
                    <div className="col-md-4">
                        <Select
                            component="Event"
                            name="event"
                            value={this.props.values.event}
                            label="Esemény"
                            filter={{
                                filters: [
                                    fieldFilter("to", moment().subtract(1, "month").format("YYYY-MM-DD"), ">="),
                                    {field: "to", operator: "isnull"},
                                ],
                                operator: "OR"
                            }}
                            order={{field: "to", direction: "ASC"}}
                            storeType="remote"
                            view={["program.name", "program.id"]}
                            selectedOptionTemplate={(props) => {
                                return <Fragment>#{props.id} Esemény ({PeriodFormatter([props.from, props.to])}) - {props.program?.name} (#{props.program?.id})</Fragment>;
                            }}
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("event")}
                        />
                    </div>
                    <div className="currency col-md-2">
                        <TextInput
                            name="saleprice"
                            type="number"
                            value={parseInt(this.props.values.saleprice || "0")}
                            formatter={CurrencyFormatter}
                            className={this.props.getFieldProps("saleprice").isLoading ? "loading" : null}
                            label="Ár"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("saleprice")}
                            disabled={disabled}
                        />
                    </div>
                    <div className={classNames({"col-md-4": this.props.presets?.event, "col-md-2": !this.props.presets?.event})}>
                        <TextInput
                            name="participant_qty"
                            type="number"
                            value={parseInt(this.props.values.participant_qty || "0")}
                            formatter={(value) => UnitFormatter(value, "Fő")}
                            label="Résztvevők/Létszám"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("participant_qty")}
                            disabled={disabled}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-3">
                        <label className="control-label">Számlázási adatok</label>
                        <div className={this.props.values[this.props.componentConfig.idfield] ? "input-group" : null}>
                            <Select
                                objectValue={true}
                                name="customer"
                                component="partner"
                                labelKey="name"
                                valueKey="partner_id"
                                storeType="remote"
                                view={["address","telnum"]}
                                value={this.props.values.customer}
                                saveChanges={this.props.setFieldValue}
                                label={false}
                                {...this.props.getFieldProps("customer")}
                            />
                            {this.props.values[this.props.componentConfig.idfield] ? <div className="input-group-btn">
                                <Button
                                    color={this.props?.values?.customer?.partner_id + "" === "" + this.props.initialValues?.customer?.partner_id ? "default" : "primary"}
                                    disabled={this.props?.values?.customer?.partner_id + "" === "" + this.props.initialValues?.customer?.partner_id || this.props.isLoading}
                                    onClick={async () => {
                                        await this.props.processAction(async () => {
                                            return postData({
                                                action: this.props.componentConfig.componentname + '.update',
                                                data: {
                                                    [this.props.componentConfig.idfield]: this.props.values[this.props.componentConfig.idfield],
                                                    customer: this.props.values.customer.partner_id
                                                }
                                            });
                                        });
                                    }}>
                                    Mentés
                                </Button>
                            </div> : null}
                        </div>
                    </div>
                    <div className="col-md-9">
                        <div className="row">
                            <AddressControl
                                disabled="disabled"
                                name="customer.address"
                                value={this.props.values.customer?.address}
                                label="Cím"
                                saveChanges={this.props.setFieldValue}
                            />
                        </div>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-4">
                        <Select
                            objectValue={true}
                            name="agent"
                            component="user"
                            labelKey="name"
                            valueKey="id"
                            storeType="remote"
                            value={this.props.values.agent}
                            saveChanges={this.props.setFieldValue}
                            optionsTemplate={optionsTemplate("person")}
                            label="Foglaló"
                            {...this.props.getFieldProps("agent")}
                        />
                    </div>
                    <div className="col-md-4">
                        <TextInput
                            {...this.props.getFieldProps("agent")}
                            disabled="disabled"
                            name="agent.email"
                            value={(this.props.values.agent || {}).email}
                            label="Email"
                        />
                    </div>
                    <div className="col-md-4">
                        <TextInput
                            {...this.props.getFieldProps("agent")}
                            disabled="disabled"
                            name="agent.telnum"
                            value={(this.props.values.agent || {}).telnum}
                            label="Telefon"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <div className="row">
                            <AddressControl
                                disabled="disabled"
                                name="agent.address"
                                value={(this.props.values.agent || {}).address}
                                label="Cím"
                                saveChanges={this.props.setFieldValue}
                            />
                        </div>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <TextArea
                            name="comment.text"
                            value={(this.props.values.comment || {}).text}
                            label="Megjegyzés"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("comment.text")}
                        />
                    </div>
                </div>
                {!this.props.values[this.props.componentConfig.idfield] && <div className="row form-row">
                    <div className="col-md-12">
                        <Select
                            optionname="paymentprovider"
                            name="payments"
                            value={this.props.values.payments?.[0].serviceprovider_type}
                            label="Fizetési mód"
                            storeType="local"
                            objectValue={false}
                            saveChanges={(field, serviceprovider_type) => {
                                this.props.setFieldValue("payments", [{serviceprovider_type}])
                            }}
                        />
                    </div>
                </div>}
                {!!this.props.values[this.props.componentConfig.idfield] && <ComponentLoader
                    componentName={this.props.componentConfig.componentname}
                    componentId={this.props.values[this.props.componentConfig.idfield]}
                    view={[this.props.componentConfig.idfield, "event"]}
                >
                    <QuizAnswers {...this.props} />
                </ComponentLoader>}
                {!!this.props.values[this.props.componentConfig.idfield] && <div className="row form-row">
                    <div className="col-md-12">
                        <label className="control-label">Kiválasztott fizetős lehetőségek</label>
                        <EventReservationOptionEditor
                            editorContext="EventReservationEventReservationOptionEditor"
                            gridid={"EventReservationEventReservationOptionList"}
                            presets={{event_reservation: this.props.values}}
                            isLoading={this.props.isLoading}
                            editor={ModalEditor}
                            list={FragmentEditor}
                            selection={null}
                            listFilter={[
                                {
                                    field: "event_reservation",
                                    value: this.props.values[this.props.componentConfig.idfield]
                                }
                            ]}
                        />
                    </div>
                </div>}
            </form>
        );
    }
}

export default connect((state) => {
    return {
        till: state.app.till
    };
}, {})(createForm(EventReservationForm));
